import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AcessoRapido } from '../models/acesso-rapido';

@Injectable({
  providedIn: 'root'
})
export class AcessoRapidoService {


  private acessosRapidosSource = new BehaviorSubject<AcessoRapido[]>([]);
  currentAcessosRapidos = this.acessosRapidosSource.asObservable();

  constructor() { }

  changeAcessosRapidos(acessoRapido: AcessoRapido[]) {
    this.acessosRapidosSource.next(acessoRapido);
  }

  clean() {
    this.acessosRapidosSource.next([]);
  }
}
